import React from 'react';
import NotificationInfo from 'src/assets/icons/NotificationInfo';
import { ONBOARDING_STEP } from 'src/data/onboarding';
import { SPOTLIGHT_TYPE } from '../components/Spotlight';

export const STEPS_EDIT_BRIEF_DATA = [
  {
    id: ONBOARDING_STEP.beReminded,
    target: '[data-onboarding="BriefEditing"]:first-of-type',
    content: {
      title: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <NotificationInfo
            color="#638BD9"
            style={{ marginRight: 8 }}
          />{' '}
          Project Brief
        </span>
      ),
      description:
        'You can review and edit the brief at any time. Anyword uses the brief to generate your copy variations. To get the best results, make sure that your brief depicts your product/service accurately.',
      next: 'Got it',
      counter: false,
      dontShowAgain: true,
    },
    options: {
      placement: 'right-start',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.circle }],
    },
  },

  {
    id: ONBOARDING_STEP.beRemindedCO,
    target: '[data-onboarding="BriefEditing"]',
    content: {
      title: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <NotificationInfo
            color="#638BD9"
            style={{ marginRight: 8 }}
          />{' '}
          Project Brief
        </span>
      ),
      description:
        'You can review and edit the brief at any time. Anyword uses the brief to generate your copy variations. To get the best results, make sure that your brief depicts your product/service accurately.',
      next: 'Got it',
      counter: false,
      dontShowAgain: true,
    },
    options: {
      placement: 'left',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.circle }],
    },
  },
];
